module.exports = __webpack_public_path__ + "static/img/login.c04ca26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login.png
// module id = Nl6a
// module chunks = 1